/// <reference path="../../app.settings.ts" />
///<reference path="../../../../typings/index.d.ts"/>
///<reference path="../short-cuts/models/short-cuts-group.model.ts"/>

module Meevo {

    import GroupLevels = Meevo.Components.ShortCuts.GroupLevels;
    import IShortCutGroupItem = Meevo.Components.ShortCuts.IShortCutGroupItem;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportCategory = Meevo.Plugins.Reports.IReportCategory;
    import IBusinessInfoDataService = Meevo.Components.Common.IBusinessInfoDataService;


    export enum MenuNavigationType {
        Convo,
        Direct,
        Url
    }

    export enum LinkType {
        SalesForceCommunity,
        MillenniumAcademy,
        MillenniumExchange,
        IdeaStartUrl,
        Integrations,
        Hardware,
        BusinessBoosters,
        KnowledgeArticles,
        MeevoPay,
    }

    export enum MenuItemLevel {
        Menu,
        SubMenu
    }

    export class MenuService {
        public menuShortCutGroup: ShortCutGroup;
        public subMenuShortCutGroup: ShortCutGroup;

        private routeNames: Meevo.Components.Common.IRouteNames;
        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private securityParts = Meevo.Components.Common.SecurityParts;
        private $translate = {};


        private meevoPayAcctMgmtMenuItem: IMenuItem;

        menuItems: IMenuItem[];
        public featureSmartTileMenuItems: IMenuItem[] = [];
        private smartTileList: string[] = [
            this.appSettings.ROUTE_NAMES.appointmentBook,
            this.appSettings.ROUTE_NAMES.register,
            this.appSettings.ROUTE_NAMES.drawerManager,
            this.appSettings.ROUTE_NAMES.callCenter,
            this.appSettings.ROUTE_NAMES.confirmationManager,
            this.appSettings.ROUTE_NAMES.timeClock,
             this.appSettings.ROUTE_NAMES.schedulesManager,
            this.appSettings.ROUTE_NAMES.waitList,
            this.appSettings.ROUTE_NAMES.walkinManagerSettings,
            this.appSettings.ROUTE_NAMES.clientPoint,
            this.appSettings.ROUTE_NAMES.reports,
            this.appSettings.ROUTE_NAMES.employeeSupplyUsage,
            this.appSettings.ROUTE_NAMES.inventoryCount,
            this.appSettings.ROUTE_NAMES.purchaseOrder,
            this.appSettings.ROUTE_NAMES.stockLevels,
            this.appSettings.ROUTE_NAMES.memberships,
            this.appSettings.ROUTE_NAMES.walkinManager,
            this.appSettings.ROUTE_NAMES.walkinManagerKiosk,
            this.appSettings.ROUTE_NAMES.walkinManagerDisplay,
            this.appSettings.ROUTE_NAMES.ratingsControlPanel,
            this.appSettings.ROUTE_NAMES.student,
            this.appSettings.ROUTE_NAMES.help
        ];
        private countryCode: string;

        private populateMenuItems(sourceItems: IMenuItem[]): void {
            sourceItems.forEach(item => {
                if (this.smartTileList.indexOf(item.stateName) !== -1) {
                    this.featureSmartTileMenuItems.push(item);
                }
                if (item.subMenuItems && item.stateName !== this.appSettings.ROUTE_NAMES.reports) {
                    this.populateMenuItems(item.subMenuItems);
                }
            });
            // TODO: Ordering by state name; currently most reliable field to order by
            this.featureSmartTileMenuItems = _.sortBy(this.featureSmartTileMenuItems, i => i.stateName);
        }

        private initMenuItems(): void {
            this.meevoPayAcctMgmtMenuItem = {
                contentKey: this.translate.instant("HERO_SUB_MEEVOPAY_ACCOUNT_MANAGEMENT"),
                icon: "meevopay_account_management",
                stateName: this.routeNames.meevoStore,
                stateParams: {
                    linkType: LinkType.MeevoPay
                },
                securityKey: this.securityKeys.MEEVOSTORE_MEEVOSTORE
            };
            this.menuItems = [
                //{
                //    id: "SAVED_CONVOS",
                //    contentKey: this.translate.instant("HERO_SAVED_CONVOS"),
                //    subMenuItems: [
                //        {
                //            contentKey: this.translate.instant("HERO_SUB_SAVED_CONVOS"),
                //            stateName: this.routeNames.home
                //        }
                //    ]
                //},
                {
                    id: "HELP",
                    contentKey: this.translate.instant("HERO_HELP"),
                    subMenuItems: [
                        {
                            id: "ideas_portal",
                            contentKey: this.translate.instant("HERO_SUB_IDEAS_PORTAL"),
                            icon: "meevo_ideas_portal_icon",
                            stateName: "ideasportal",
                            securityKey: this.securityKeys.HELP_IDEASPORTAL
                        },
                        {
                            id: "meevo-help",
                            contentKey: this.translate.instant("HERO_SUB_HELP"),
                            icon: "meevo_help_icon",
                            stateName: this.routeNames.help,
                            securityKey: this.securityKeys.HELP_HELP
                        },
                        {
                            id: "meevo-academy",
                            contentKey: this.translate.instant("HERO_SUB_ACADEMY"),
                            icon: "meevo_academy_icon",
                            stateName: "academy",
                            securityKey: this.securityKeys.HELP_ACADEMY
                        },
                        {
                            id: 'meevo-inspo',
                            contentKey: this.translate.instant('LABEL_MEEVO_INSPO'),
                            icon: 'meevo_inspo_icon',
                            stateName: this.routeNames.meevoInspo,
                            securityKey: this.securityKeys.HELP_MEEVOINSPO,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.millenniumInspoUrl;
                                    });
                            }
                        },
                        {
                            id: 'meevo-remote-traning',
                            contentKey: this.translate.instant('LABEL_BOOK_REMOTE_TRAINING'),
                            icon: 'meevo_remote_training',
                            stateName: this.routeNames.remoteTraining,
                            securityKey: this.securityKeys.HELP_BOOKREMOTETRAINING,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.bookRemoteTrainingUrl;

                                    });
                            }
                        },
                        {
                            id: 'refer-a-friend',
                            contentKey: this.translate.instant('LABEL_REFER_A_FRIEND'),
                            icon: 'meevo_refer_a_friend_icon',
                            stateName: this.routeNames.referAFriend,
                            securityKey: this.securityKeys.HELP_REFERAFRIEND,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.referAFriendUrl;
                                    });
                            }
                        },
                        {
                            id: 'meevo-facebook',
                            contentKey: this.translate.instant('LABEL_MEEVO_FACEBOOK_GROUP'),
                            icon: 'meevo_facebook_group_icon',
                            stateName: this.routeNames.meevoFacebook,
                            securityKey: this.securityKeys.HELP_MEEVOFACEBOOKGROUP,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.meevoFacebookGroupUrl;
                                    });
                            }
                        },
                        {
                            id:'system-versions',
                            contentKey: this.translate.instant("LABEL_SYSTEM_VERSION_INFO"),
                            icon: "meevo_help_icon",
                            stateName: this.routeNames.systemVersions,
                        },
                        {
                            id: 'millennium-release-notes',
                            contentKey: this.translate.instant('LABEL_RELEASE_NOTE'),
                            icon: 'meevo_release_notes_icon',
                            stateName: this.routeNames.meevoInspo,
                            securityKey: this.securityKeys.HELP_RELEASENOTES,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.releaseNotesUrl;
                                    });
                            }
                        },
                        {
                            id: "adv-dashboards-help",
                            contentKey: this.translate.instant("LABEL_ADVANCED_DASHBOARDS_HELP"),
                            icon: "meevo_advanced_dashboards_help_icon",
                            stateName: this.routeNames.advancedDashboardsHelp,
                            securityKey: this.securityKeys.HELP_ADVANCEDDASHBOARDS,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.dashboardsHelpUrl;
                                    });
                            }
                        },
                        {

                            id: "knowledge-articles",
                            contentKey: this.translate.instant("LABEL_KNOWLEDGE_ARTICLES"),
                            icon: "meevo_knowledge_articles_icon",
                            stateName: this.routeNames.knowledgeArticles,
                            securityKey: this.securityKeys.HELP_KNOWLEDGEARTICLES,
                            isNewWindowPromise: () => {
                                return this.businessInfoDataService
                                    .getBusinessInfoPreferences()
                                    .then((busInfo) => {
                                        return busInfo.helpSectionSettings.knowledgeArticlesUrl;
                                    });
                            }

                        },

                    ],
                    securityKey: this.securityKeys.HELP,
                    shortCut: 'NAV_MENU_HELP',
                },
                {
                    id: 'SMART_CENTER',
                    contentKey: this.translate.instant('HERO_SUB_SMARTCENTER'),
                    subMenuItems: [
                        {
                            id: 'smart-center',
                            contentKey: this.translate.instant('HERO_SUB_SMARTCENTER'),
                            icon: 'open_smartcenter',
                            stateName: this.appSettings.ROUTE_NAMES.home,
                            securityKey: this.securityKeys.SMARTCENTER_SMARTCENTER,
                            shortCut: 'NAV_MENU_SMART_CENTER_SMART_CENTER',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SMARTCENTER_DESIGNER"),
                            icon: "meevo_smart_center_designer_icon",
                            stateName: this.routeNames.smartCenters,
                            securityKey: this.securityKeys.DATA_SMARTCENTERDESIGNER
                        }
                    ],
                    securityKey: this.securityKeys.SMARTCENTER,
                    shortCut: 'NAV_MENU_SMART_CENTER',
                },
                {
                    id: "DATA",
                    contentKey: this.translate.instant("HERO_DATA"),
                    subMenuItems: [
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_BASIC_MARKETING"),
                        //    icon: "meevo_basic_email",
                        //    stateName: this.routeNames.basicEmailMarketing,
                        //    securityKey: this.securityKeys.MANAGEMENT_BASICMARKETING
                        //},
                        {
                            id: "businesstype",
                            contentKey: this.translate.instant("HERO_SUB_BUSTYPE"),
                            icon: "meevo_business_info_icon",
                            stateName: this.routeNames.businessTypes,
                            securityKey: this.securityKeys.DATA_BUSINESSTYPE
                        },
                        {
                            id: "locationGroup",
                            contentKey: this.translate.instant("HERO_SUB_LOCATIONGROUP"),
                            icon: "meevo_confirmation_manager",   // needs its own icon
                            stateName: this.routeNames.locationGroups,
                            securityKey: this.securityKeys.DATA_LOCATIONGROUP
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CLIENTS"),
                            icon: "icon_clients_icon",
                            stateName: this.routeNames.client,
                            securityKey: this.securityKeys.DATA_CLIENT,
                            shortCut: 'NAV_MENU_DATA_CLIENTS',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CLIENTCLIENTTYPE"),
                            icon: "meevo_client_types_icon",
                            stateName: this.routeNames.clientClientType,
                            securityKey: this.securityKeys.DATA_CLIENTCLIENTTYPE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEES"),
                            icon: "meevo_employee_icon",
                            stateName: this.routeNames.employee,
                            securityKey: this.securityKeys.DATA_EMPLOYEE,
                            shortCut: 'NAV_MENU_DATA_EMPLOYEE',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_TEACHERS"),
                            icon: "meevo_teachers_icon",
                            stateName: this.routeNames.teachers,
                            securityKey: this.securityKeys.DATA_TEACHER,
                            isHiddenInCallCenter: true
                        },
                        this.interopMenuItem(this.translate.instant("HERO_SUB_PRODUCT_BULK_UPDATE"),
                            `meevo_product_bulk_update`,
                            this.routeNames.productBulkUpdate,
                            this.securityKeys.DATA_PRODUCTBULKUPDATE,
                            this.routeNames.productBulkUpdate),
                        //{
                        //  contentKey: this.translate.instant("HERO_SUB_ONLINE_BOOKING_OPTIONS"),
                        //  icon: "meevo_online_options",
                        //  //stateName: this.routeNames.employee
                        //},
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_CANCELLATION_REASONS"),
                        //    icon: "meevo_cancellation_type_icon",
                        //    stateName: this.routeNames.cancellationReasons,
                        //    securityKey: this.securityKeys.DATA_CANCELLATIONREASON
                        //},
                        {
                            contentKey: this.translate.instant("HERO_SUB_SERVICES"),
                            icon: "meevo_service_icon",
                            stateName: this.routeNames.services,
                            securityKey: this.securityKeys.DATA_SERVICE,
                            shortCut: 'NAV_MENU_DATA_SERVICE',
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_REFERRAL_TYPES"),
                            icon: "meevo_referral_type_icon",
                            stateName: this.routeNames.referralTypes,
                            securityKey: this.securityKeys.DATA_REFERRALTYPE
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_BLOCK_TYPES"),
                        //    icon: "meevo_block_type",
                        //    stateName: this.routeNames.blockTypes,
                        //    securityKey: this.securityKeys.DATA_BLOCKTYPE
                        //},
                        {
                            contentKey: this.translate.instant("HERO_SUB_VISIT_NOTE_TYPES"),
                            icon: "meevo_visit_notes_icon",
                            stateName: this.routeNames.visitNoteTypes,
                            securityKey: this.securityKeys.DATA_VISITNOTETYPE,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DISTRIBUTORS"),
                            icon: "meevo_distributors",
                            stateName: this.routeNames.distributors,
                            securityKey: this.securityKeys.DATA_DISTRIBUTOR,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MANUFACTURERS"),
                            icon: "meevo_manufacturers",
                            stateName: this.routeNames.manufacturers,
                            securityKey: this.securityKeys.DATA_MANUFACTURER,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SERVICE_CAT"),
                            icon: "meevo_service_cat_icon",
                            stateName: this.routeNames.serviceCategories,
                            securityKey: this.securityKeys.DATA_SERVICECATEGORY,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PRODUCT_CAT"),
                            icon: "meevo_product_cat_icon",
                            stateName: this.routeNames.productCategories,
                            securityKey: this.securityKeys.DATA_PRODUCTCATEGORY,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "EMPLOYEETEMPLATEPROMOTIONS",
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEE_TEMPLATE_PROMOTIONS"),
                            icon: "meevo_employee_promotions_icon",
                            stateName: this.routeNames.employeeTemplatePromotions,
                            securityKey: this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEE_TEMPLATE"),
                            icon: "meevo_employee_templates_icon",
                            stateName: this.routeNames.employeeTemplates,
                            securityKey: this.securityKeys.DATA_EMPLOYEETEMPLATE

                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEE_CATEGORY"),
                            icon: "employee_cat_icon",
                            stateName: this.routeNames.employeeCategories,
                            securityKey: this.securityKeys.DATA_EMPLOYEECATEGORY
                        },
                        {
                            id: "resources",
                            contentKey: this.translate.instant("HERO_SUB_RESOURCES"),
                            icon: "meevo_resources",
                            stateName: this.routeNames.resources,
                            securityKey: this.securityKeys.DATA_RESOURCE,
                            isHiddenInCallCenter: true
                        },

                        {
                            contentKey: this.translate.instant("HERO_SUB_RESOURCE_CATEGORIES"),
                            icon: "meevo_resources_category",
                            stateName: this.routeNames.resourceCategory,
                            securityKey: this.securityKeys.DATA_RESOURCECATEGORY,
                            isHiddenInCallCenter: true
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_APPOINTMENT_CATEGORY"),
                        //    icon: "meevo_appointment_category",
                        //    stateName: this.routeNames.appointmentCategories,
                        //    securityKey: this.securityKeys.DATA_APPOINTMENTCATEGORY
                        //},
                        {
                            contentKey: this.translate.instant("HERO_SUB_PRODUCTS"),
                            icon: "meevo_products",
                            stateName: this.routeNames.product,
                            securityKey: this.securityKeys.DATA_PRODUCT,
                            shortCut: 'NAV_MENU_DATA_PRODUCT',
                            isHiddenInCallCenter: true
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_PRODUCT_BULK_UPDATE"),
                        //    icon: "meevo_product_bulk_update",
                        //    stateName: this.routeNames.productBulkUpdate,
                        //    securityKey: this.securityKeys.DATA_PRODUCTBULKUPDATE,
                        //    isHiddenInCallCenter: true
                        //},
                        {
                            contentKey: this.translate.instant("HERO_SUB_PRODUCT_BUNDLES"),
                            icon: "meevo_product_bundles",
                            stateName: this.routeNames.productBundles,
                            securityKey: this.securityKeys.DATA_PRODUCTBUNDLE,
                            isHiddenInCallCenter: true
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_WORK_ACTIVITY"),
                        //    icon: "meevo_work_activities_icon",
                        //    stateName: this.routeNames.workActivities,
                        //    securityKey: this.securityKeys.DATA_WORKACTIVITY
                        //},
                        {
                            id: "user_defined_controls", // Used to conditionally remove
                            contentKey: this.translate.instant("HERO_SUB_USER_DEFINED_FIELDS"),
                            icon: "meevo_user_defined_controls_icon",
                            stateName: this.routeNames.userDefinedControls,
                            securityKey: this.securityKeys.DATA_USERDEFINEDCONTROLS
                        },
                        //              {
                        //                  contentKey: this.translate.instant("HERO_SUB_RESOURCES"),
                        //                  icon: "meevo_visit_notes_icon",
                        //                  stateName: this.routeNames.resources,
                        //                  securityKey: this.securityKeys.DATA_VISITNOTETYPE
                        //              },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EQUIPMENT"),
                            icon: "meevo_equipment_icon",
                            stateName: this.routeNames.equipment,
                            securityKey: this.securityKeys.DATA_EQUIPMENT,
                            isHiddenInCallCenter: true
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_PAYMENTTYPE"),
                        //    icon: "meevo_payment_types_icon",
                        //    stateName: this.routeNames.paymentType,
                        //    securityKey: this.securityKeys.DATA_PAYMENTTYPE
                        //},
                        {
                            contentKey: this.translate.instant("HERO_SUB_PACKAGES"),
                            icon: "meevo_packages_icon",
                            stateName: this.routeNames.packageTypes,
                            securityKey: this.securityKeys.DATA_PACKAGETYPE,
                            shortCut: 'NAV_MENU_DATA_PACKAGE',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PACKAGE_SWAP_GROUPS"),
                            icon: "meevo_swap_group_icon",
                            stateName: this.routeNames.swapGroups,
                            securityKey: this.securityKeys.DATA_SWAPGROUP,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SERVICES_ADDONGROUP"),
                            icon: "meevo_add_on_group_icon",
                            stateName: this.routeNames.addOnGroup,
                            securityKey: this.securityKeys.DATA_ADDONGROUP,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "imageGalleryCategory",
                            contentKey: this.translate.instant("HERO_SUB_IMAGE_GALLERY_CAT"),
                            icon: "meevo_Image_gallery_cat_icon",
                            stateName: this.routeNames.imageGalleryCategory,
                            securityKey: this.securityKeys.DATA_IMAGEGALLERYCATEGORY
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DEPARTMENTS"),
                            icon: "meevo_department",
                            stateName: this.routeNames.departments,
                            securityKey: this.securityKeys.DATA_DEPARTMENT,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SERVICEWIZARD"),
                            icon: "services_wizard",
                            stateName: this.routeNames.servicesWizard,
                            securityKey: this.securityKeys.DATA_SERVICESWIZARD
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_STUDENT"),
                            icon: "student_icon",
                            stateName: this.routeNames.student,
                            securityKey: this.securityKeys.DATA_STUDENT,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: 'clientintake',
                            contentKey: this.translate.instant("HERO_SUB_NEW_CLIENTINTAKE"),
                            icon: "client_intakeform",
                            stateName: this.routeNames.clientIntake,
                            securityKey: this.securityKeys.DATA_CLIENTINTAKEFORM,
                            isHiddenInCallCenter: true
                        },
                    ],
                    securityKey: this.securityKeys.DATA,
                    shortCut: 'NAV_MENU_DATA'
                },
                {
                    id: "PBI-DASHBOARDS",
                    contentKey: this.translate.instant("LABEL_DASHBOARDS"),
                    subMenuItems: [this.interopMenuItem(this.translate.instant("LABEL_ADVANCED_DASHBOARDS"), `meevo_advanced_dashboards_icon`, this.routeNames.pbiDashboards, this.securityKeys.POWERBIDASHBOARDS_DATAGROUP, `${this.routeNames.pbiDashboards}`)],
                    securityKey: this.securityKeys.POWERBIDASHBOARDS_DATAGROUP,
                    shortCut: ''
                },
                {
                    id: "SCHEDULES",
                    contentKey: this.translate.instant("HERO_SCHEDULES"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_TIME_CLOCK"),
                            stateName: this.routeNames.timeClock,
                            icon: "meevo_time_clock",
                            securityKey: this.securityKeys.SCHEDULES_TIMECLOCK,
                            shortCut: 'NAV_MENU_SCHEDULES_TIME_CLOCK',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_WORK_ACTIVITY"),
                            icon: "meevo_work_activities_icon",
                            stateName: this.routeNames.workActivities,
                            securityKey: this.securityKeys.DATA_WORKACTIVITY,
                            shortCut: 'NAV_MENU_SCHEDULES_WORK_ACTIVITIES',
                        },
                        this.interopMenuItem(this.translate.instant("Schedule Manager"), `meevo_reports_scheduler`, this.routeNames.schedulesManager, this.securityKeys.SCHEDULES_CALENDAR, this.routeNames.schedulesManager, 'NAV_MENU_SCHEDULES_SCHEDULES'),

                    ],
                    securityKey: this.securityKeys.SCHEDULES,
                    shortCut: 'NAV_MENU_SCHEDULES',
                },
                {
                    id: "APPOINTMENT",
                    contentKey: this.translate.instant("HERO_APPOINTMENT"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_1_APPOINTMENTBOOK"),
                            stateName: this.routeNames.appointmentBook,
                            icon: "meevo_appointment_book",
                            navigationType: MenuNavigationType.Convo,
                            navigationTarget: 'appointment book',
                            securityKey: this.securityKeys.APPOINTMENTS_APPOINTMENTBOOK,
                            shortCut: 'NAV_MENU_APPOINTMENT_APPOINTMENT_BOOK',
                            position: 1,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_APPOINTMENT_CATEGORY"),
                            icon: "meevo_appointment_category",
                            stateName: this.routeNames.appointmentCategories,
                            securityKey: this.securityKeys.DATA_APPOINTMENTCATEGORY,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_BLOCK_TYPES"),
                            icon: "meevo_block_type",
                            stateName: this.routeNames.blockTypes,
                            securityKey: this.securityKeys.DATA_BLOCKTYPE,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CANCELLATION_REASONS"),
                            icon: "meevo_cancellation_type_icon",
                            stateName: this.routeNames.cancellationReasons,
                            securityKey: this.securityKeys.DATA_CANCELLATIONREASON,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_STANDING_APPOINTMENTS"),
                            stateName: this.routeNames.standingAppointments,
                            icon: "meevo_standing_definitions",
                            securityKey: this.securityKeys.APPOINTMENTS_STANDINGDEFINITION,
                            shortCut: 'NAV_MENU_APPOINTMENT_STANDING_APPOINTMENTS',
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_STANDING_BLOCKS"),
                            stateName: this.routeNames.standingBlocks,
                            icon: "meevo_block_definitions",
                            securityKey: this.securityKeys.APPOINTMENTS_BLOCKDEFINITION,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "bookingAgent",
                            contentKey: this.translate.instant("HERO_SUB_CALL_CENTER"),
                            icon: "meevo_callcenter_icon",
                            stateName: this.routeNames.callCenter,
                            securityKey: this.securityKeys.APPOINTMENTS_CALLCENTERMANAGER,
                            notMobileFriendly: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CONFIRMATION_MANAGER"),
                            stateName: this.routeNames.confirmationManager,
                            icon: "meevo_confirmation_manager",
                            securityKey: this.securityKeys.APPOINTMENTS_CONFIRMATIONMANAGER,
                            shortCut: 'NAV_MENU_APPOINTMENT_CONFIRMATION_MANAGER',
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_WAIT_LIST"),
                            icon: "meevo_wait_list",
                            stateName: this.routeNames.waitList,
                            securityKey: this.securityKeys.APPOINTMENTS_WAITLIST,
                            shortCut: 'NAV_MENU_APPOINTMENT_WAIT_LIST',
                            isHiddenInCallCenter: true
                        },

                        {
                            contentKey: this.translate.instant("HERO_SUB_WALKIN_MANAGER"),
                            icon: "meevo_walkin_manager",
                            stateName: this.routeNames.walkinManager,
                            securityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGER,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "walkin-kiosk",
                            contentKey: this.translate.instant("HERO_SUB_WALKIN_MANAGER_KIOSK"),
                            icon: "meevo_walkin_manager_kiosk",
                            stateName: this.routeNames.walkinManagerKiosk,
                            securityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERKIOSK,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_WALKIN_MANAGER_DISPLAY"),
                            icon: "meevo_walkin_manager_display",
                            stateName: this.routeNames.walkinManagerDisplay,
                            securityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERDISPLAY,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("LABEL_SELF_CHECK_IN_KIOSK"),
                            icon: "meevo_self_check_in_kiosk",
                            stateName: this.routeNames.selfCheckInKiosk,
                            securityKey: this.securityKeys.APPOINTMENTS_SELFCHECKINKIOSK
                        }
                    ],
                    securityKey: this.securityKeys.APPOINTMENTS,
                    shortCut: 'NAV_MENU_APPOINTMENT'
                },
                {
                    id: "REGISTER",
                    contentKey: this.translate.instant("HERO_REGISTER"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_1_REGISTER"),
                            icon: "meevo_register",
                            stateName: this.routeNames.register,
                            securityKey: this.securityKeys.REGISTER_REGISTER,
                            shortCut: 'NAV_MENU_REGISTER_REGISTER',
                            position: 1
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DISCOUNTS"),
                            icon: "meevo_discounts",
                            stateName: this.routeNames.discounts,
                            securityKey: this.securityKeys.REGISTER_DISCOUNTS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DRAWER"),
                            icon: "meevo_drawer",
                            stateName: this.routeNames.drawer,
                            securityKey: this.securityKeys.REGISTER_DRAWER
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DRAWER_HISTORY"),
                            icon: "meevo_drawer_history",
                            stateName: this.routeNames.drawerHistory,
                            securityKey: this.securityKeys.REGISTER_DRAWERHISTORY,
                            shortCut: 'NAV_MENU_REGISTER_DRAWER_HISTORY',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DRAWER_MANAGER"),
                            icon: "meevo_drawer_manager",
                            stateName: this.routeNames.drawerManager,
                            securityKey: this.securityKeys.REGISTER_DRAWERMANAGER,
                            shortCut: 'NAV_MENU_REGISTER_DRAWER_MANAGER',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PAYINOUT_REASON"),
                            icon: "meevo_pay_in_out_icon",
                            stateName: this.routeNames.payinoutreasons,
                            securityKey: this.securityKeys.REGISTER_PAYINOUTREASON
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_POS_HARDWARE"),
                            icon: "meevo_pos_hardware",
                            stateName: this.routeNames.posHardware,
                            securityKey: this.securityKeys.REGISTER_POSHARDWARE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_TRANSACTION_EDITOR"),
                            icon: "meevo_transaction_editor",
                            stateName: this.routeNames.transactionEditor,
                            securityKey: this.securityKeys.REGISTER_TRANSACTIONEDITOR,
                            shortCut: 'NAV_MENU_REGISTER_TRANSACTION_EDITOR',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MERCHANT_ACCOUNTS"),
                            icon: "meevo_merchant_account",
                            stateName: this.routeNames.merchantAccounts,
                            securityKey: this.securityKeys.REGISTER_MERCHANTACCOUNT
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MARK_ITEMS_ON_SALE"),
                            icon: "meevo_mark_items_on_sale",
                            stateName: this.routeNames.saleProgram,
                            securityKey: this.securityKeys.REGISTER_SALEPROGRAM
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PAYMENTTYPE"),
                            icon: "meevo_payment_types_icon",
                            stateName: this.routeNames.paymentType,
                            securityKey: this.securityKeys.DATA_PAYMENTTYPE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_GIFT_CARD_TYPES"),
                            icon: "meevo_giftcard_types_icon",
                            stateName: this.routeNames.giftCardTypes,
                            securityKey: this.securityKeys.DATA_GIFTCARDTYPE
                        },
                        {
                            contentKey: this.translate.instant('HERO_SUB_EMPLOYEE_SERVICE_TIMES_PRICING'),
                            icon: "meevo_emp_service_icon",
                            stateName: this.routeNames.employeeServiceTimesPricing,
                            securityKey: this.securityKeys.REGISTER_REGISTER_EMPLOYEESERVICETIMESPRICING,
                            shortCut: 'NAV_MENU_REGISTER_EMPLOYEE_SERVICE_TIMES_PRICING'
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_GIFT_CARD_LOOKUP"),
                            icon: "meevo_giftcard_lookup_icon",
                            stateName: this.routeNames.giftCardBalance,
                            securityKey: this.securityKeys.REGISTER_REGISTER_GIFTCARDLOOKUP
                        },
                        {
                            contentKey: this.translate.instant('HERO_SUB_SHIPPING_FEES'),
                            icon: "meevo_shipping_fees",
                            stateName: this.routeNames.shippingFees,
                            securityKey: this.securityKeys.REGISTER_SHIPPINGFEES,
                        }
                    ],
                    securityKey: this.securityKeys.REGISTER,
                    shortCut: 'NAV_MENU_REGISTER',
                },
                {
                    id: "MEMBERSHIP",
                    contentKey: this.translate.instant("HERO_MEMBERSHIP"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEMBERSHIPS"),
                            icon: "meevo_memberships_icon",
                            stateName: this.routeNames.memberships,
                            securityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIP
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEMBERSHIP_TYPES"),
                            icon: "meevo_membership_types_icon",
                            stateName: this.routeNames.membershipTypes,
                            securityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEMBERSHIP_BENEFIT_TEMPLATES"),
                            icon: "meevo_membership_benefit_templates_icon",
                            stateName: this.routeNames.memberBenefitTemplates,
                            securityKey: this.securityKeys.MEMBERSHIP_MEMBERBENEFITTEMPLATE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEMBERSHIP_CANCELLATION_REASONS"),
                            icon: "meevo_membership_cancellation_icon",
                            stateName: this.routeNames.membershipCancellation,
                            securityKey: this.securityKeys.MEMBERSHIP_CANCELLATIONREASON
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEMBERSHIP_MANAGER"),
                            icon: "meevo_membership_manager_icon",
                            stateName: this.routeNames.membershipManager,
                            securityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER,
                            shortCut: 'NAV_MENU_MEMBERSHIP_MEMBERSHIP_MANAGER',
                        },
                        {
                            id: 'eft-control-panel',
                            contentKey: this.translate.instant("HERO_SUB_EFT_CONTROL_PANEL"),
                            icon: "meevo_eft_control_panel_icon",
                            stateName: this.routeNames.eftControlPanel,
                            securityKey: this.securityKeys.MEMBERSHIP_EFTCONTROLPANEL,
                            shortCut: 'NAV_MENU_MEMBERSHIP_EFT_CONTROL_PANEL',
                        },
                        this.interopMenuItem(this.translate.instant("LABEL_MEMBERSHIP_ONLINE_SETTINGS"),
                            `online_membership_settings_icon`,
                            this.routeNames.onlineMembershipSettings,
                            this.securityKeys.MEMBERSHIP_ONLINEMEMBERSHIPSETTINGS,
                            this.routeNames.onlineMembershipSettings),

                    ],
                    securityKey: this.securityKeys.MEMBERSHIP,
                    shortCut: 'NAV_MENU_MEMBERSHIP',
                },
                {
                    id: "INVENTORY",
                    contentKey: this.translate.instant("HERO_INVENTORY"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_STOCK_LEVELS"),
                            stateName: this.routeNames.stockLevels,
                            icon: "meevo_inventory_stocklevel_icon",
                            securityKey: this.securityKeys.INVENTORY_STOCKLEVEL,
                            shortCut: 'NAV_MENU_INVENTORY_STOCK_LEVELS',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_INVENTORY_COUNT"),
                            stateName: this.routeNames.inventoryCount,
                            icon: "meevo_inventory_count_icon",
                            securityKey: this.securityKeys.INVENTORY_COUNT,
                            shortCut: 'NAV_MENU_INVENTORY_INVENTORY_COUNT',

                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PURCHASE_ORDERS"),
                            stateName: this.routeNames.purchaseOrder,
                            icon: "meevo_purchase_orders_icon",
                            securityKey: this.securityKeys.INVENTORY_PURCHASEORDER,
                            shortCut: 'NAV_MENU_INVENTORY_PURCHASE_ORDERS',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_INVENTORY_RETURNS"),
                            stateName: this.routeNames.inventoryReturns,
                            icon: "meevo_inventory_returns_icon",
                            securityKey: this.securityKeys.INVENTORY_RETURNS,
                            shortCut: 'NAV_MENU_INVENTORY_INVENTORY_RETURNS',

                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEE_SUPPLY_USAGE"),
                            stateName: this.routeNames.employeeSupplyUsage,
                            icon: "meevo_employee_supply_usage_icon",
                            securityKey: this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE,
                            shortCut: 'NAV_MENU_INVENTORY_EMPLOYEE_SUPPLY_USAGE',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MISC_SUPPLIES"),
                            stateName: this.routeNames.miscSupplyDefinitions,
                            icon: "meevo_misc_supplies",
                            securityKey: this.securityKeys.INVENTORY_MISCSUPPLYDEFINITIONS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_FLOOR_LOCATIONS"),
                            icon: "meevo_floor_location_icon",
                            stateName: this.routeNames.floorLocation,
                            securityKey: this.securityKeys.INVENTORY_FLOORLOCATION
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_INVENTORY_TRANSFER"),
                            icon: "meevo_inventory_transfer_icon",
                            stateName: this.routeNames.inventoryTransfer,
                            securityKey: this.securityKeys.INVENTORY_TRANSFER
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_USAGE_REASONS"),
                            icon: "meevo_inventory_transfer_icon",
                            stateName: this.routeNames.usageReasons,
                            securityKey: this.securityKeys.INVENTORY_USAGEREASON
                        }
                    ],
                    securityKey: this.securityKeys.INVENTORY,
                    shortCut: 'NAV_MENU_INVENTORY',
                    isHiddenInCallCenter: true
                },
                {
                    id: "GOALS",
                    contentKey: this.translate.instant("HERO_GOALS"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_DASHBOARD_GOALS"),
                            icon: "meevo_goals_dashboard",
                            stateName: this.routeNames.dashboardGoals,
                            securityKey: this.securityKeys.GOALS_GOALSDASHBOARD
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DEPARTMENT_GOALS"),
                            icon: "meevo_goals_department",
                            stateName: this.routeNames.departmentGoal,
                            securityKey: this.securityKeys.GOALS_OVERALLDEPARTMENTGOALS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EMPLOYEE_GOALS"),
                            icon: "meevo_goals_employee",
                            stateName: this.routeNames.employeeGoal,
                            securityKey: this.securityKeys.GOALS_EMPLOYEEGOALS
                        }
                    ],
                    securityKey: this.securityKeys.GOALS,
                    isHiddenInCallCenter: true
                },
                {
                    id: "REPORTS",
                    contentKey: this.translate.instant("HERO_REPORTS"),
                    stateName: this.routeNames.reports,
                    subMenuItems: [
                        {
                            id: "analytical",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_ANALYTICAL"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_analytical",
                            securityKey: this.securityKeys.REPORTS_ANALYTICAL,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Analytical
                            }
                        },
                        {
                            id: "appointments",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_APPOINTMENTS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_appointments",
                            securityKey: this.securityKeys.REPORTS_APPOINTMENTS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Appointments
                            }
                        },
                        {
                            id: "clients",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_CLIENTS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_clients",
                            securityKey: this.securityKeys.REPORTS_CLIENTS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Clients
                            }
                        },
                        {
                            id: "employee",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_EMPLOYEE"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_employees",
                            securityKey: this.securityKeys.REPORTS_EMPLOYEE,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Employee
                            }
                        },
                        {
                            id: "frontdesk",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_FRONT_DESK"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_frontdesk",
                            securityKey: this.securityKeys.REPORTS_FRONTDESK,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.FrontDesk
                            }
                        },
                        {
                            id: "inventory",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_INVENTORY"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_inventory",
                            securityKey: this.securityKeys.REPORTS_INVENTORY,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Inventory
                            }
                        },
                        {
                            id: "liabilities",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_LIABILITIES"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_liabilities",
                            securityKey: this.securityKeys.REPORTS_LIABILITIES,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Liabilities
                            }
                        },
                        {
                            id: "memberships",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_MEMBERSHIPS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_memberships",
                            securityKey: this.securityKeys.REPORTS_MEMBERSHIPS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Memberships
                            }
                        },
                        {
                            id: "payroll",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_PAYROLL"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_payroll",
                            securityKey: this.securityKeys.REPORTS_PAYROLL,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Payroll
                            }
                        },
                        {
                            id: "products",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_PRODUCTS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_products",
                            securityKey: this.securityKeys.REPORTS_PRODUCTS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Products
                            }
                        },
                        {
                            id: "referrals",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_REFERRALS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_referrals",
                            securityKey: this.securityKeys.REPORTS_REFERRALS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Referrals
                            }
                        },
                        {
                            id: "registersales",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_REGISTERSALES"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_registermgmt",
                            securityKey: this.securityKeys.REPORTS_REGISTERSALES,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Register
                            }
                        },
                        {
                            id: "schedules",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_SCHEDULES"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_schedules",
                            securityKey: this.securityKeys.REPORTS_SCHEDULES,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.Schedules
                            }
                        },
                        {
                            id: "walkins",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_WALKINS"),
                            stateName: this.routeNames.reports,
                            icon: "meevo_reports_walkins",
                            securityKey: this.securityKeys.REPORTS_WALKINS,
                            stateParams: {
                                categoryId: Meevo.Model.ReportsCategoryEnum.WalkIns
                            }
                        },
                    ],
                    securityKey: this.securityKeys.REPORTS
                },
                {
                    id: "MANAGEMENT",
                    contentKey: this.translate.instant("HERO_MANAGEMENT"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_EGIFT"),
                            icon: "meevo_egifts",
                            stateName: this.routeNames.egifts,
                            securityKey: this.securityKeys.MANAGEMENT_EGIFT
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SECURITY_ROLE"),
                            icon: "meevo_security_roles",
                            stateName: this.routeNames.securityRoles,
                            securityKey: this.securityKeys.MANAGEMENT_SECURITYROLE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SECURITY_ROLE_MANAGER"),
                            icon: "meevo_security_roles_manager",
                            stateName: this.routeNames.securityRolesManager,
                            securityKey: this.securityKeys.MANAGEMENT_SECURITYROLESMANAGER

                        },
                        {
                            id: "client-merge",
                            contentKey: this.translate.instant("HERO_SUB_INTELLI_MERGE"),
                            icon: "meevo_client_merge",
                            stateName: this.routeNames.clientMerge,
                            securityKey: this.securityKeys.MANAGEMENT_CLIENTMERGE
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MANUAL_MERGE"),
                            icon: "meevo_manual_merge",
                            stateName: this.routeNames.clientManualMerge,
                            securityKey: this.securityKeys.MANAGEMENT_MANUALMERGECLIENTS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_LOCATIONS"),
                            icon: "meevo_location_icon",
                            stateName: this.routeNames.location,
                            securityKey: this.securityKeys.MANAGEMENT_LOCATION
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEEVO_THEMING"),
                            icon: "meevo_theming",
                            stateName: this.routeNames.meevoTheming,
                            securityKey: this.securityKeys.MANAGEMENT_MEEVOTHEMING,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "integrations",
                            contentKey: this.translate.instant("HERO_SUB_INTEGRATIONS"),
                            icon: "meevo_integrations_icon",
                            stateName: this.routeNames.integrations,
                            securityKey: this.securityKeys.MANAGEMENT_INTEGRATION,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "client-points-manager",
                            contentKey: this.translate.instant("HERO_SUB_CLIENTS_POINTS"),
                            icon: "meevo_points_icon",
                            stateName: this.routeNames.clientPoint,
                            securityKey: this.securityKeys.MANAGEMENT_CLIENTPOINT,
                            shortCut: 'NAV_MENU_MANAGEMENT_CLIENT_POINTS_MANAGER',
                            isHiddenInCallCenter: true
                        },
                        this.interopMenuItem(this.translate.instant("HERO_SUB_CLIENT_RECORD_MANAGEMENT"),
                            `meevo_client_record_management_icon`,
                            this.routeNames.clientRecordManagement,
                            this.securityKeys.MANAGEMENT_CLIENTRECORDMANAGEMENT,
                            this.routeNames.clientRecordManagement.toLowerCase()),
                        {
                            contentKey: this.translate.instant("HERO_SUB_PAYROLL"),
                            stateName: this.routeNames.payroll,
                            icon: "meevo_payroll_icon",
                            securityKey: this.securityKeys.MANAGEMENT_PAYROLL,
                            shortCut: 'NAV_MENU_MANAGEMENT_PAYROLL',
                        },
                        //{
                        //    contentKey: this.translate.instant("HERO_SUB_PROACTIVE_ALERTS"),
                        //    stateName: this.routeNames.inventoryReturns, /*Placeholder: Change when ready to develope*/
                        //    icon: "meevo_proactive_alerts_icon",
                        //    securityKey: this.securityKeys.INVENTORY_PURCHASEORDER, /*Placeholder: Change when ready to develope*/
                        //    isDisabled: true // todo: remove when plugin is ready
                        //},
                        {
                            id: "marketpricing",
                            contentKey: this.identityService.inCentralOfficeMode() ? this.translate.instant("HERO_SUB_MARKET_PRICING") : this.translate.instant("HERO_SUB_PRICE_MANAGEMENT"),
                            icon: "meevo_price_management_icon",
                            stateName: this.routeNames.marketPricing,
                            securityKey: this.identityService.inCentralOfficeMode() ? this.securityKeys.MANAGEMENT_MARKETPRICING : this.securityKeys.MANAGEMENT_PRICEMANAGEMENT,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "meevo-messenger",
                            contentKey: this.translate.instant("HERO_SUB_MEEVO_MESSENGER"),
                            icon: "meevo_messenger_icon",
                            stateName: this.routeNames.meevoMessenger,
                            securityKey: this.securityKeys.MANAGEMENT_MEEVOMESSENGER
                        },
                        {
                            id: "reportscheduler",
                            contentKey: this.translate.instant("HERO_SUB_REPORTS_SCHEDULER"),
                            stateName: this.routeNames.reportScheduler,
                            icon: "meevo_reports_scheduler",
                            securityKey: this.securityKeys.MANAGEMENT_REPORTSCHEDULE,
                        },
                        {
                            id: "custom-branding-classic",
                            contentKey: this.translate.instant("HERO_SUB_CUSTOM_BRANDING"),
                            icon: "meevo_custom_branding_icon",
                            stateName: this.routeNames.customBranding,
                            securityKey: this.securityKeys.MANAGEMENT_CUSTOMBRANDING
                        },
                        this.interopMenuItem(this.translate.instant("HERO_SUB_CUSTOM_BRANDING"), `meevo_custom_branding_icon`, this.routeNames.advancedCustomBranding, this.securityKeys.MANAGEMENT_CUSTOMBRANDING, this.routeNames.advancedCustomBranding),
                        {
                            contentKey: this.translate.instant("HERO_SUB_ACTIVITY_LOG"),
                            icon: "meevo_activity_log_icon",
                            stateName: this.routeNames.activityLog,
                            securityKey: this.securityKeys.MANAGEMENT_ACTIVITYLOG,
                            shortCut: 'NAV_MENU_MANAGEMENT_ACTIVITY_LOG',
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_ALERTS_MANAGER"),
                            icon: "meevo_alerts_manager_icon",
                            stateName: this.routeNames.alertsManager,
                            securityKey: this.securityKeys.MANAGEMENT_ALERTSMANAGER
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_ALERTS_LOG"),
                            icon: "meevo_alerts_log_icon",
                            stateName: this.routeNames.alertsLog,
                            securityKey: this.securityKeys.MANAGEMENT_ALERTSLOG,
                            shortCut: 'NAV_MENU_MANAGEMENT_ALERTS_LOG',
                        },
                        this.interopMenuItem(this.translate.instant("HERO_SUB_CHARTS"), `meevo_charts_icon`, this.routeNames.charts, this.securityKeys.MANAGEMENT_CHARTS, this.routeNames.charts.toLowerCase()),
                        {
                            contentKey: this.translate.instant("HERO_SUB_SANDBOX"),
                            icon: "meevo_sandbox_icon",
                            stateName: this.routeNames.sandbox,
                            securityKey: this.securityKeys.MANAGEMENT_SANDBOX
                        },

                        {
                            id: "client-point-promotions",
                            contentKey: this.translate.instant("HERO_SUB_CLIENT_POINT_PROMOTIONS"),
                            icon: "meevo_client_point_promotion",
                            stateName: this.routeNames.pointPromotionCampaign,
                            securityKey: this.securityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_DOCS_AND_FORMS"),
                            icon: "meevo_docs_and_forms",
                            stateName: this.routeNames.docsAndForms,
                            securityKey: this.securityKeys.MANAGEMENT_DOCSANDFORMS
                        },
                        {
                            id: "sales-rankings",
                            contentKey: this.translate.instant("HERO_SUB_SALES_RANKINGS"),
                            icon: "meevo_topn_bottomn",
                            stateName: this.routeNames.salesRankings,
                            securityKey: this.securityKeys.MANAGEMENT_SALESRANKING,
                            shortCut: 'NAV_MENU_MANAGEMENT_SALES_RANKINGS',
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "ratings-control-panel",
                            contentKey: this.translate.instant("HERO_SUB_RATINGS_CONTROL_PANEL"),
                            icon: "meevo_ratings_control_icon",
                            stateName: this.routeNames.ratingsControlPanel,
                            securityKey: this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CLIENTINTAKE_FORM_BUILDER"),
                            icon: "client_intakeform_builder",
                            stateName: this.routeNames.clientIntakeForm,
                            securityKey: this.securityKeys.MANAGEMENT_CLIENTINTAKEFORMBUILDER_TAB_FORMBUILDER
                        },
                        {
                            id: "royalty-export",
                            contentKey: this.translate.instant("LABEL_ROYALTY_EXPORT"),
                            icon: "meevo_royalty_export_icon",
                            stateName: this.routeNames.royaltyExport,
                            securityKey: this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS
                        },
                        {
                            id: "yield-management-strategy",
                            contentKey: this.translate.instant("LABEL_YIELD_MANAGEMENT_STRATEGY"),
                            icon: "meevo_yield_management_strategy_icon",
                            stateName: this.routeNames.yieldManagementStrategy,
                            securityKey: this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY
                        },
                        {
                            id: "yield-management-program",
                            contentKey: this.translate.instant("LABEL_YIELD_MANAGEMENT_PROGRAM"),
                            icon: "meevo_yield_management_program_icon",
                            stateName: this.routeNames.yieldManagementProgram,
                            securityKey: this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM // TODO: change security key
                        },
                        this.interopMenuItem(this.translate.instant("LABEL_DATA_EXPORT"), `meevo_service_icon`, this.routeNames.csvExport, this.securityKeys.CSVEXPORT, this.routeNames.csvExport),
                        this.interopMenuItem(this.translate.instant("HERO_PAYMENT_PLANS"), `meevo_payment_plan`, this.routeNames.paymentPlans, this.securityKeys.MANAGEMENT_PAYMENTPLANMANAGER, this.routeNames.paymentPlans),
                        this.interopMenuItem(this.translate.instant("LABEL_TIME_OFF_REQUESTS"), `timeoff_request_icon`, this.routeNames.timeOffRequests, this.securityKeys.MANAGEMENT_TIMEOFFREQUESTS, this.routeNames.timeOffRequests),
                        this.interopMenuItem(this.translate.instant("LABEL_BULK_LIABILITY_UPDATE"), `meevo_bulk_liability_update_icon`, this.routeNames.bulkLiabilityUpdate, this.securityKeys.MANAGEMENT_BULKLIABILITYUPDATE, this.routeNames.bulkLiabilityUpdate),
                        this.interopMenuItem(this.translate.instant("LABEL_BULK_LIABILITY_TRANSFER"), `meevo_bulk_liability_transfer_icon`, this.routeNames.bulkLiabilityTransfer, this.securityKeys.MANAGEMENT_BULKLIABILITYTRANSFER, this.routeNames.bulkLiabilityTransfer),

                    ],
                    securityKey: this.securityKeys.MANAGEMENT,
                    shortCut: 'NAV_MENU_MANAGEMENT'
                },
                {
                    id: "MARKETING",
                    contentKey: this.translate.instant("HERO_MENU_MARKETING"),
                    subMenuItems: [
                        {
                            id: "basic-marketing",
                            contentKey: this.translate.instant("HERO_SUB_BASIC_MARKETING"),
                            icon: "meevo_basic_email",
                            stateName: this.routeNames.basicEmailMarketing,
                            securityKey: this.securityKeys.MARKETING_BASICMARKETING,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "emma-account-settings",
                            contentKey: this.translate.instant("LABEL_EMAIL_MARKETING"),
                            icon: "meevo_emma",
                            stateName: this.routeNames.emmaAccountSettings,
                            securityKey: this.securityKeys.MARKETING_EMMA
                        },
                        {
                            contentKey: this.translate.instant("YEXT_HERO_ONLINE_PRESENCE_MANAGEMENT"),
                            icon: "yext_online_presence_management",
                            stateName: this.routeNames.onlinePresenceManagement,
                            securityKey: this.securityKeys.MARKETING_ONLINEPRESENCEMANAGEMENT
                        },
                        {
                            contentKey: this.translate.instant("HEADER_ONLINE_PRESENCE_SETTINGS"),
                            icon: "yext_online_presence_settings",
                            stateName: this.routeNames.onlinePresenceSettings,
                            securityKey: this.securityKeys.MARKETING_ONLINEPRESENCESETTINGS
                        }
                    ],
                    securityKey: this.securityKeys.MARKETING
                },
                {
                    id: "MEEVO_PAY",
                    contentKey: this.translate.instant("LABEL_MEEVO_PAY"),
                    subMenuItems: [
                        this.meevoPayAcctMgmtMenuItem,
                        this.interopMenuItem(this.translate.instant("HERO_SUB_MEEVOPAY_APPLICATION"),
                            `meevopay_application_setup`,
                            this.routeNames.meevoPay,
                            this.securityKeys.MEEVOPAY,
                            'meevo-pay/merchant-account'),
                    ],
                },
                {
                    id: "BUSINFO",
                    contentKey: this.translate.instant("HEADER_BUSSETTINGS"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_BUSINFO"),
                            icon: "meevo_business_info_icon",
                            stateName: this.routeNames.businessInfo,
                            securityKey: this.securityKeys.DATA_BUSINESSINFO,
                            shortCut: 'NAV_MENU_BUSINFO_BUSINFO',
                        },
                        this.interopMenuItem(this.translate.instant("HERO_SUB_BUSPREFS"),
                            `meevo_business_pref_icon`,
                            this.routeNames.businessPreferences,
                            this.securityKeys.DATA_BUSINESSINFO_TAB_PREFERENCES,
                            this.routeNames.businessPreferences),
                        {
                            contentKey: this.translate.instant("HERO_SUB_HOLIDAYS"),
                            stateName: this.routeNames.holiday,
                            icon: "meevo_holiday_icon ",
                            securityKey: this.securityKeys.BUSINESSINFO_HOLIDAYS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_IP_Restrictions"),
                            icon: "meevo_ip_restrictions_icon",
                            stateName: this.routeNames.ipRestrictions,
                            securityKey: this.securityKeys.MANAGEMENT_IPRESTRICTION
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_NOTIFICATIONSETTING"),
                            stateName: this.routeNames.notificationSetting,
                            icon: "meevo_inventory_notification_setting_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_NOTIFICATIONS,
                            isHiddenInCallCenter: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_NOTIFICATION_TEMPLATES"),
                            icon: "meevo_notification_templates",
                            stateName: this.routeNames.notificationTemplates,
                            securityKey: this.securityKeys.BUSINESSINFO_NOTIFICATIONTEMPLATE, //MANAGEMENT_NOTIFICATIONTEMPLATE
                            isHiddenInCallCenter: true,
                            notMobileFriendly: true
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CURRENCYTAX"),
                            stateName: this.routeNames.tax,
                            icon: "meevo_tax_setting_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_FINANCIAL
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_EVENTS"),
                            stateName: this.routeNames.eventSchedules,
                            icon: "meevo_events_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_EVENTSCHEDULE,
                            shortCut: 'NAV_MENU_BUSINFO_EVENTS',
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "compensationsettings",
                            contentKey: this.translate.instant("HERO_SUB_PAYROLLSETTINGS"),
                            stateName: this.routeNames.compensationSettings,
                            icon: "meevo_compensation_settings_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS
                        },
                        {
                            id: "culturesettings",
                            contentKey: this.translate.instant("HERO_SUB_CULTURESETTINGS"),
                            stateName: this.routeNames.cultureSettings,
                            icon: "meevo_culture_settings_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_CULTURESETTINGS
                        },
                        {
                            id: "filedlabels",
                            contentKey: this.translate.instant("HERO_SUB_FIELDLABELS"),
                            stateName: this.routeNames.fieldLabels,
                            icon: "meevo_field_labels_icon",
                            securityKey: this.securityKeys.BUSINESSINFO_FIELDLABELS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_ONLINE_BOOKING_SETTINGS"),
                            icon: "meevo_online_booking_settings",
                            stateName: this.routeNames.onlineBookingSettings,
                            securityKey: this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_WALKIN_MANAGER_SETTINGS"),
                            icon: "meevo_walkin_manager_settings",
                            stateName: this.routeNames.walkinManagerSettings,
                            securityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: "reporting-hierarchy",
                            contentKey: this.translate.instant("HERO_SUB_REPORTING_HIERARCHY"),
                            icon: "meevo_block_type",
                            stateName: this.routeNames.reportingHierarchy,
                            securityKey: this.securityKeys.BUSINESSINFO_REPORTHIERARCHY
                        },
                        {
                            id: 'self-check-in-kiosk-settings',
                            contentKey: this.translate.instant('HERO_SUB_SELF_CHECK_IN_SETTINGS'),
                            icon: 'meevo_self_check_in_kiosk_settings',
                            stateName: this.routeNames.selfCheckInKioskSettings,
                            securityKey: this.securityKeys.BUSINESSINFO_SELFCHECKINKIOSKSETTINGS,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: 'five-star-rating-settings',
                            contentKey: this.translate.instant('LABEL_FIVE_STAR_RATING_SETTINGS'),
                            icon: 'meevo_five_star_rating_settings',
                            stateName: this.routeNames.fiveStarRatingSetting,
                            securityKey: this.securityKeys.BUSINESSINFO_FIVESTARRATINGSSETTINGS,
                            isHiddenInCallCenter: true
                        },
                        {
                            id: 'service-charges',
                            contentKey: this.translate.instant('Service Charges'),
                            icon: "meevo_service_icon",
                            stateName: this.routeNames.serviceCharges,
                            securityKey: this.securityKeys.BUSINESSINFO_SERVICECHARGES
                        },
                        {
                            id: "system-toolbox",
                            contentKey: this.translate.instant("HERO_SUB_MEEVO_SYSTEM_TOOLBOX"),
                            icon: "meevo_system_toolbox_icon",
                            stateName: this.routeNames.systemToolbox,
                            securityKey: this.securityKeys.BUSINESSINFO_SYSTEMTOOLBOX,
                            isHiddenInCallCenter: true
                        },
                        this.interopMenuItem(this.translate.instant("SECTION_TWO_WAY_SMS_ONBOARDING"),
                            `meevo_two_way_sms_onboarding`,
                            this.routeNames.twoWaySmsOnboarding,
                            this.securityKeys.BUSINESSINFO_TWOWAYSMSONBOARDING,
                            this.routeNames.twoWaySmsOnboarding),
                    ],
                    securityKey: this.securityKeys.BUSINESSINFO,
                    shortCut: 'NAV_MENU_BUSINFO',
                },
                {
                    id: "INTEGRATION",
                    contentKey: this.translate.instant("HERO_INTEGRATION"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("LABEL_EMPOWERED_ORDERING"),
                            icon: "meevo_aveda",
                            stateName: this.routeNames.aveda,
                            securityKey: this.securityKeys.INTEGRATION_AVEDA
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_TRANSWORLD"),
                            icon: "meevo_transworld",
                            stateName: this.routeNames.transworld,
                            securityKey: this.securityKeys.INTEGRATION_TRANSWORLD
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_QUICKBOOKS"),
                            icon: "meevo_quickbooks",
                            stateName: this.routeNames.accountsync,
                            securityKey: this.securityKeys.INTEGRATION_QUICKBOOKS
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_QUICKBOOKS_DESKTOP"),
                            icon: "meevo_quickbooks_desktop",
                            stateName: this.routeNames.quickbooksDesktop,
                            securityKey: this.securityKeys.INTEGRATION_QUICKBOOKSDESKTOP
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_SALON_CONNECT"),
                            icon: "meevo_consumer_app_settings",
                            stateName: this.routeNames.consumerAppSettings,
                            isNewWindow: true,
                            newWindowUrl: '',
                            urlApi: 'consumerAppSettings',
                            securityKey: this.securityKeys.INTEGRATION_SALONCLOUD
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_PAGING"),
                            icon: "meevo_paging",
                            stateName: this.routeNames.paging,
                            securityKey: this.securityKeys.INTEGRATION_PAGING
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_TEXTEL_BLAST"),
                            icon: "meevo_textel_blast",
                            stateName: this.routeNames.textelBlast,
                            securityKey: this.securityKeys.INTEGRATION_TEXTELMARKETING
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_TECHSPHERE"),
                            icon: "meevo_referral_type_icon",
                            stateName: this.routeNames.techSphere,
                            securityKey: this.securityKeys.INTEGRATION_TECHSPHERE
                        },
                        {
                            contentKey: this.translate.instant('INTEGRATION_MEEVOBI'),
                            icon: 'meevo_meevo_bi_icon',
                            stateName: this.routeNames.meevoBi,
                            securityKey: this.securityKeys.INTEGRATION_MEEVOBI
                        },
                        {
                            contentKey: this.translate.instant('HERO_SUB_FAME_ADVANTAGE'),
                            icon: 'meevo_fame_advantage_icon',
                            stateName: this.routeNames.fameAdvantage,
                            securityKey: this.securityKeys.INTEGRATION_FAMEADVANTAGE
                        },
                        {
                            contentKey: this.translate.instant("LABEL_ADP_PAYROLL_INTEGRATION"),
                            icon: "meevo_adp_run_integration_icon",
                            stateName: this.routeNames.adpRunIntegration,
                            securityKey: this.securityKeys.INTEGRATION_ADPINTEGRATION
                        },
                        {
                            contentKey: this.translate.instant("LABEL_ADP_WFN_PAYROLL_INTEGRATION"),
                            icon: "meevo_adp_wfn_integration_icon",
                            stateName: this.routeNames.adpWfnIntegration,
                            securityKey: this.securityKeys.INTEGRATION_ADPWFNINTEGRATION
                        },
                        {
                            contentKey: this.translate.instant("LABEL_ADP_WISELY_INTEGRATION"),
                            icon: "meevo_adp_wisely_integration_icon",
                            stateName: this.routeNames.adpWiselyIntegration,
                            securityKey: this.securityKeys.INTEGRATION_ADPWISELYINTEGRATION
                        },
                        {
                            id: "clientApp",
                            contentKey: this.translate.instant("INTEGRATION_CLIENTAPP"),   //UPDATEHERE
                            icon: "meevo_mego_icon",                               //UPDATEHERE meevo_client_app_icon
                            stateName: this.routeNames.clientApp,                       //UPDATEHERE
                            securityKey: this.securityKeys.INTEGRATION_CLIENTAPP       //UPDATEHERE
                        },
                        {
                            id: "customBrandedApp",
                            contentKey: this.translate.instant("INTEGRATION_CUSTOMBRANDEDAPP"),
                            icon: "meevo_mego_custombrandedapp_icon",
                            stateName: this.routeNames.clientApp,
                            securityKey: this.securityKeys.INTEGRATION_CUSTOMBRANDEDAPP
                        },
                        {
                            id: "tippy",
                            contentKey: this.translate.instant("LABEL_TIPPY_INTEGRATION"),
                            icon: "meevo_tippy_icon",
                            stateName: this.routeNames.tippy,
                            securityKey: this.securityKeys.INTEGRATION_TIPPY
                        },
                        this.interopMenuItem(this.translate.instant("LABEL_MY_MEEVO_APP"),
                            `my_meevo_app`,
                            this.routeNames.myMeevoApp,
                            this.securityKeys.INTEGRATION_MYMEEVOAPP,
                            this.routeNames.myMeevoApp),
                        this.interopMenuItem(this.translate.instant("LABEL_ZAPIER_INTEGRATION"),
                            "meevo_zapier_icon",
                            this.routeNames.zapier,
                            this.securityKeys.INTEGRATION_ZAPIER,
                            this.routeNames.zapier,
                        ),
                        this.interopMenuItem(this.translate.instant("LABEL_SALON_INTERACTIVE"),
                            "salon_interactive_icon",
                            this.routeNames.salonInteractive,
                            this.securityKeys.INTEGRATION_SALONINTERACTIVE,
                            this.routeNames.salonInteractive),
                    ],
                    securityKey: this.securityKeys.INTEGRATION
                },
                {
                    id: "MEEVOSTORE",
                    contentKey: this.translate.instant("HEADER_MEEVOSTORE"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_MEEVOSTORE"),
                            id: "SUBMEEVOSTORE",
                            icon: "meevo_store",
                            stateName: this.routeNames.meevoStore,
                            securityKey: this.securityKeys.MEEVOSTORE_MEEVOSTORE
                        }
                    ],
                    securityKey: this.securityKeys.MEEVOSTORE
                },
                {
                    id: "INTERNAL",
                    contentKey: this.translate.instant("HERO_INTERNAL"),
                    subMenuItems: [
                        {
                            contentKey: this.translate.instant("HERO_SUB_STYLEGALLERY"),
                            stateName: this.routeNames.styleGallery
                        },
                        {
                            contentKey: this.translate.instant("HERO_SUB_CONTROLGALLERY"),
                            stateName: this.routeNames.controlGallery
                        }],
                    securityKey: this.securityKeys.INTERNAL
                }

            ];
            // FIll menu items available for navigation via smart tiles
            this.populateMenuItems(this.menuItems);

            // Remove items not supported by CO
            if (this.identityService.inCentralOfficeMode()) {
                // List items not supported in CO mode
                this.removeMenuItem("INTEGRATION", "tippy");
                this.removeMenuItem("MEEVOSTORE", null);
                this.removeMenuItem("MEEVO_PAY", null);

                // Change context title for CO mode
                let marketPricing = <IContext>_.findWhere(this.$state.get(), { name: this.routeNames.marketPricing });
                if (marketPricing) {
                    marketPricing.title = 'Market Pricing';
                }
            } else {
                // List items not supported in location mode
                this.removeMenuItem("MANAGEMENT", "reporting-hierarchy");
            }

            // Remove items not supported by Call Center Location
            if (this.identityService.inCallCenterMode() && !this.identityService.isEmulating) {
                this.menuItems = this.removeMenuItemsForCallCenter(this.menuItems);
            }

            // Remove Community Site and Millenium Academy links Menu if User doesn't have SalesForceId
            if (!this.identityService.current().salesForceId) {
                this.removeMenuItem("HELP", "community-site");
                this.removeMenuItem("HELP", "meevo-academy");
                this.removeMenuItem("HELP", "ideas_portal");
                this.removeMenuItem("HELP", "knowledge-articles")
            }
            if (this.identityService.current()["userTypeEnum"] != 2084) {
                this.removeMenuItem("BUSINFO", "emma-account-settings");
                this.removeMenuItem("HELP", 'system-versions');
            }

            //Depends on security keys will be displayed clientApp or customBrandedApp icon
            this.securityService.checkSecurityKey(this.securityKeys.INTEGRATION_CUSTOMBRANDEDAPP + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then(result => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        this.removeMenuItem("INTEGRATION", "clientApp");
                    }
                    else {
                        this.removeMenuItem("INTEGRATION", "customBrandedApp");
                    }
                });

            let arrivalsKey = this.securityKeys.MANAGEMENT_MEEVOMESSENGER_ARRIVALS + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            let textelKey = this.securityKeys.INTEGRATION_TEXTEL + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            let twoWaySms = this.securityKeys.INTEGRATION_TWOWAYSMS + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            let meGoKey = this.securityKeys.INTEGRATION_CLIENTAPP_TAB_MESSENGER + Meevo.Components.Common.SecurityParts.KEY_PART_READ;

            this.securityService.checkSecurityKey(arrivalsKey).then((arrivalsPermission) => {
                if (arrivalsPermission !== Meevo.Model.SecurityAccessEnum.Grant) return;

                this.$q.all([
                    this.securityService.checkSecurityKey(textelKey),
                    this.securityService.checkSecurityKey(meGoKey),
                    this.securityService.checkSecurityKey(twoWaySms),
                    this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.notificationSetting}`, 'GET', null)
                ]).then(([textelPermission, meGoPermission, twoWaySmsPermission ,notificationSetting]) => {
                    const arrivalsConfig: any = _.findWhere(notificationSetting.data.communicationTypeNotifications, { communicationType: Meevo.Model.CommunicationTypeEnum.AppointmentCheckIn });
                    const isTextelOrTwoWaySmsOrMeGoNotGrant =
                        textelPermission !== Meevo.Model.SecurityAccessEnum.Grant &&
                        meGoPermission !== Meevo.Model.SecurityAccessEnum.Grant &&
                        twoWaySmsPermission !== Meevo.Model.SecurityAccessEnum.Grant;

                    if (isTextelOrTwoWaySmsOrMeGoNotGrant && !(arrivalsConfig && arrivalsConfig.isSMSEnabled)) {
                        this.securityService.setRootKeytoHide(this.securityKeys.MANAGEMENT_MEEVOMESSENGER + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                    }
                });

            });

            //Remove reports category without report
            this.securityService.checkSecurityKey(this.securityKeys.REPORTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then(result => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        this.dataService
                            .getListPaged('Report/ReportCategory', {
                                criteria: {
                                    isContainsReports: true,
                                    objectStateEnum: ObjectStateEnum.Active
                                }
                            })
                            .then((result: Array<IReportCategory>) => {
                                let reportSubMenuItems = [..._.findWhere(this.menuItems, { id: 'REPORTS' }).subMenuItems];
                                let availableCategories = result.map(r => this.reportsHelper.reportNameToSecurityKey(r.displayName).toLowerCase());

                                reportSubMenuItems.forEach(item => {
                                    if (availableCategories.indexOf(item.id) === -1 && item.id != "reportscheduler") {
                                        this.removeMenuItem('REPORTS', item.id);
                                    }
                                })
                            });
                    }
                });

            //Remove items not supported on mobile devices
            if ((/Mobile/i.test(navigator.userAgent) && !/ipad/i.test(navigator.userAgent))) {

                //List items not supported on mobile
            }

            // Remove EFT Control panel for UK
            if (this.countryCode === 'GB') {
                this.removeMenuItem("MEMBERSHIP", "eft-control-panel");
            }

            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.egifts}/settings`, 'GET', null)
                .then(res => {
                    const eGiftsSettings = res && res.data && res.data.settings as Model.EGiftsSettings;
                    const menuIdToRemove = eGiftsSettings && eGiftsSettings.enableNewEgiftExperience ? "custom-branding-classic" : this.routeNames.advancedCustomBranding;
                    this.removeMenuItem("MANAGEMENT", menuIdToRemove)
                });

            this.generateMenuShortCutGroup();
        }

        // TODO: Refactor into recursive function
        removeMenuItem(parentKey: string, childKey: string) {
            var parentItem = _.find(this.menuItems, p => p.id === parentKey);
            if (Model.Guard.isNothing(parentItem)) {
                return;
            }
            if (Model.Guard.isNothing(childKey)) {
                // Remove parent
                var indexParent = this.menuItems.indexOf(parentItem);
                this.menuItems.splice(indexParent, 1);
            }
            else {
                // Find child
                var childItem = _.find(parentItem.subMenuItems, c => (<any>c).id === childKey);
                if (Model.Guard.isNothing(childItem)) {
                    return;
                }
                // Remove child
                var indexChild = parentItem.subMenuItems.indexOf(childItem);
                parentItem.subMenuItems.splice(indexChild, 1);
            }
        }

        removeMenuItemsForCallCenter(menuItems: IMenuItem[]): IMenuItem[] {
            var filteredMenuItems: IMenuItem[] = [];
            menuItems.forEach(menuItem => {
                if (!menuItem.isHiddenInCallCenter) {
                    if (menuItem.subMenuItems && menuItem.subMenuItems.length > 0) {
                        menuItem.subMenuItems = this.removeMenuItemsForCallCenter(menuItem.subMenuItems);
                    }
                    filteredMenuItems.push(menuItem);
                }
            });

            return filteredMenuItems;
        }

        /**
         * Initiates the load of permissions for security related to menu items. This should typically complete before the menu is first opened.
         */
        private initMenuSecurity(): void {

            // First, get set of permissions that control access to menu items. This isn't mandatory, but saves a unique call for every
            // individual security key that's defined for a menu item when they first render.
            let menuItemSecurityKeys = _.union(
                _(this.menuItems).map((o) => o.securityKey),
                _.chain(this.menuItems).map((o) => o.subMenuItems).flatten().map((o) => o.securityKey).filter(undefined).value()
            );

            // We want the "READ" permission
            menuItemSecurityKeys = menuItemSecurityKeys.map(key => key + Meevo.Components.Common.SecurityParts.KEY_PART_READ);

            // Get the keys
            this.securityService.checkAndCache(menuItemSecurityKeys).then(() => {
                this.loggingService.info('Menu security initialized...');

                if (this.meevoPayAcctMgmtMenuItem) {
                    const meevoStoreAccess = this.securityService.checkCachedSecurityKey(this.securityKeys.MEEVOSTORE_MEEVOSTORE + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                    const meevoPayAccess = this.securityService.checkCachedSecurityKey(this.securityKeys.MEEVOPAY + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                    // MEEVOSTORE is the default. Use MEEVOPAY if it is more restrictive.
                    if (meevoPayAccess < meevoStoreAccess) {
                        this.meevoPayAcctMgmtMenuItem.securityKey = this.securityKeys.MEEVOPAY;
                    }
                }

                this.setRootMenuSecurity();

            }).catch(() => {
                this.loggingService.error('There was a problem getting the security keys for the main menu so menu creation cannot continue.');
            });

        }

        private setRootMenuSecurity(): void {
            var menuItemsToKeep: IMenuItem[] = [];
            for (var index = 0; index < this.menuItems.length; index++) {

                if (!this.menuItems[index].securityKey || 
                    this.securityService.checkCachedSecurityKey(this.menuItems[index].securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ) > 2054) {
                    var count = 0;
                    for (var subIndex = 0; subIndex < this.menuItems[index].subMenuItems.length; subIndex++) {
                        if (this.securityService.checkCachedSecurityKey(
                            this.menuItems[index].subMenuItems[subIndex].securityKey +
                            Meevo.Components.Common.SecurityParts.KEY_PART_READ) >
                            2054) {
                            count++;
                        }
                    }

                    if (this.menuItems[index].subMenuItems.length === 0 && this.menuItems[index].securityPassIfEmpty) {
                        count++;
                    }

                    if (count > 0)
                        menuItemsToKeep.push(this.menuItems[index]);
                    //else {

                    //    this.securityService.setRootKeytoHide(this.menuItems[index].securityKey +
                    //        Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                    //}

                }
            }
            this.menuItems = menuItemsToKeep;


        }

        //public openMeevoHelp() {
        //    let helpUrl = this.identityService.current().systemSettings.meevoLocationHelpUrl;
        //    if (this.identityService.current().centralOfficeId === this.identityService.current().locationId) {
        //        return this.identityService.current().systemSettings.meevoCoHelpUrl;
        //    }
        //    if (this.identityService.current().isSingleLocation) {
        //        return  this.identityService.current().systemSettings.meevoSingleLocationHelpUrl;
        //    }


        //    if (!_.isEmpty(helpUrl)) {
        //        return helpUrl;

        //    }
        //}

        public openMeevoHelp(): void {
            let helpUrl = this.identityService.current().systemSettings.meevoLocationHelpUrl;
            if (this.identityService.current().centralOfficeId === this.identityService.current().locationId) {
                helpUrl = this.identityService.current().systemSettings.meevoCoHelpUrl;
            }
            if (this.identityService.current().isSingleLocation) {
                helpUrl = this.identityService.current().systemSettings.meevoSingleLocationHelpUrl;
            }
            if (!_.isEmpty(helpUrl)) {
                this.$window.open(helpUrl, '_blank', 'toolbar=0,location=0,menubar=0');
            }
        }


        public generateMenuShortCutGroup() {
            this.menuShortCutGroup = this.generateShortCutGroup(this.menuItems, MenuItemLevel.Menu)
        }

        public generateSubMenuShortCutGroup(parentMenuItem: IMenuItem) {
            this.subMenuShortCutGroup = this.generateShortCutGroup(parentMenuItem.subMenuItems, MenuItemLevel.SubMenu)
        }

        public activateMenuShortCutGroup() {
            setTimeout(() => {
                this.shortKeysService.activateGroup(this.menuShortCutGroup);
            });
        }

        public activateSubMenuShortCutGroup() {
            setTimeout(() => {
                this.shortKeysService.activateGroup(this.subMenuShortCutGroup);
            });
        }

        public deactivateMenuShortCutGroup() {
            setTimeout(() => {
                this.shortKeysService.deactivateGroup(this.menuShortCutGroup);
            });
        }

        public deactivateSubMenuShortCutGroup() {
            setTimeout(() => {
                this.shortKeysService.deactivateGroup(this.subMenuShortCutGroup);
            });
        }

        public refreshCallCenterMenuItems() {
            this.initMenuItems();
            this.initMenuSecurity();
        }

        private generateShortCutGroup(menuItems: IMenuItem[], menuLevel: MenuItemLevel): ShortCutGroup {
            let eventMessage: string;
            let groupLevel: GroupLevels;

            switch (menuLevel) {
                case MenuItemLevel.Menu:
                    eventMessage = Meevo.Components.Common.Messages.MENU_SHORT_CUT_CLICK;
                    groupLevel = GroupLevels.Menu;
                    break;
                case MenuItemLevel.SubMenu:
                    eventMessage = Meevo.Components.Common.Messages.SUB_MENU_SHORT_CUT_CLICK;
                    groupLevel = GroupLevels.SubMenu;
                    break;
            }

            let groupOptions: IShortCutGroupItem[] = menuItems
                .filter(menuItem => !!menuItem.shortCut)
                .map(menuItem => ({
                    shortCutName: menuItem.shortCut,
                    callback: () => {
                        this.$rootScope.$broadcast(eventMessage, menuItem);
                    }
                }));

            return new ShortCutGroup(groupOptions, {
                groupLevel,
                deactivateGlobal: true,
                noun: Meevo.Model.NounEnum.MenuKeyboardShortcut
            });
        }

        private interopMenuItem(contentKey: string, icon: string, stateName: string, securityKey: string, targetRoute: string, shortCut?: string) {
            const menuItem = {
                id: stateName,
                contentKey,
                icon,
                stateName,
                securityKey,
                shortCut,
                stateParams: {
                    interopParams: {
                        targetRoute,
                        isInterop: true
                    }
                }
            };
            return menuItem;
        }

        constructor(
            protected $rootScope: angular.IRootScopeService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private securityService: Meevo.Components.Common.ISecurityService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private $state: ng.ui.IStateService,
            private $window: ng.IWindowService,
            private $q: ng.IQService,
            private shortKeysService: Meevo.Components.ShortCuts.IShortCutsService,
            private translate: angular.translate.ITranslateService,
            private reportsHelper: Meevo.Plugins.Reports.IReportsHelper,
            private businessInfoDataService: IBusinessInfoDataService) {
            this.routeNames = appSettings.ROUTE_NAMES;
            this.$translate = translate;

            this.$rootScope.$on(Meevo.Components.Common.Messages.AUTHENTICATION_SUCCESS, (event: angular.IAngularEvent, data: Meevo.Components.Common.IIdentity) => {
                this.countryCode = appSettings.APP_ISOCOUNTRYCODE;

                if (typeof this.appSettings.APP_FIELDLABELS.then === 'function') {
                    this.appSettings.APP_FIELDLABELS.then((data) => {
                        var check = data;
                        this.initMenuItems();
                        this.initMenuSecurity();
                    });
                } else {
                    this.appSettings.SECURITY_ACCESS_KEYS.then((keysItem) => {
                        this.initMenuItems();
                        this.initMenuSecurity();
                    });
                }
            })

        }

        static factory(): Function {
            let svc = (
                $rootScope: angular.IRootScopeService,
                appSettings: Meevo.Components.Common.IAppSettings,
                securityService: Meevo.Components.Common.ISecurityService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                identityService: Meevo.Components.Common.IIdentityService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                $state: ng.ui.IStateService,
                $window: ng.IWindowService,
                $q: ng.IQService,
                shortKeysService: Meevo.Components.ShortCuts.IShortCutsService,
                translate: angular.translate.ITranslateService,
                reportsHelper: Meevo.Plugins.Reports.IReportsHelper,
                businessInfoDataService: IBusinessInfoDataService) => {
                return new MenuService($rootScope, appSettings, securityService, loggingService, identityService, dataService, $state, $window, $q, shortKeysService, translate, reportsHelper, businessInfoDataService);
            };

            svc.$inject = [
                "$rootScope",
                "meevo.AppSettings",
                "meevo.components.common.SecurityService",
                "meevo.components.logging.LoggingService",
                "meevo.components.common.IdentityService",
                "meevo.components.common.DataService",
                "$state",
                "$window",
                "$q",
                "meevo.components.short-cuts.ShortCutsService",
                "$translate",
                "meevo.plugins.reports.ReportsHelper",
                "meevo.components.common.BusinessInfoDataService",
            ];

            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevo.menuService", MenuService.factory());
}
